import React from 'react';
import checker from '../images/checker.png';

const FunctionSection = ({ title, items }) => (
  <div>
    <h4 className={'mb-8 p-4 bg-btn-purple rounded-3xl text-center text-white'}>{title}</h4>
    <ul className={'pl-1 flex flex-col gap-4 text-sm custom-list-style'}>
      {items.map(el => (
        <li key={el} className={'flex gap-2'}>
               <img src={checker} alt="checker" style={{ width: '30px', height: '30px' }} />
          {el}
        </li>
      ))}
    </ul>
  </div>
);

export default FunctionSection;